module.exports = __webpack_public_path__ + "static/img/190419.719e981.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/events/190419.png
// module id = HItr
// module chunks = 0